document.querySelectorAll('.page-map-catalog').forEach((el) => {
    const btnsFilters = el.querySelectorAll('*[data-open-filters]');
    const btnsMap = el.querySelectorAll('button[data-open-map]');
    const btnSearch = el.querySelectorAll('.IndexMainFilters__actions button[data-search], .IndexMainFilters__close');
    const mapEl = el.querySelector('.MapCatalogBlock');
    const catalogListCloseBtn = el.querySelector('.page-map-catalog__list-close');

    if (!window.$isMobile) {
        el.classList.add('page-map-catalog--filters');
    }

    btnsFilters.forEach((btn) => {
        btn.addEventListener('click', () => {
            setMapFilters(true);
            setMapListObject(false);
        });
    })
    btnsMap.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            setMapFilters(false);
            setMapListObject(false);
        });
    })

    btnSearch.forEach((btn) => {
        btn.addEventListener('click', () => {
            //el.classList.add('page-map-catalog--catalog');
            //el.classList.remove('page-map-catalog--filters');
            setMapFilters(false);
        });
    })

    mapEl.addEventListener('map-object', () => {
        /*if(!window.$isMobile) {
            el.classList.add('page-map-catalog--catalog');
        }*/
        setMapFilters(false);
    });

    if(catalogListCloseBtn) {
        catalogListCloseBtn.addEventListener('click', () => {
            setMapListObject(false);
        });
    }
});

function setMapListObject(state) {
    const el = document.querySelector('.page-map-catalog');
    el.classList.toggle('page-map-catalog--catalog', state);
    mapResize();
}
function setMapFilters(state) {
    const el = document.querySelector('.page-map-catalog');
    el.classList.toggle('page-map-catalog--filters', state);
    mapResize();
}

function mapResize() {
    if(window.MapApp) {
        window.MapApp.map.container.fitToViewport();
        setTimeout(() => {
            window.MapApp.map.container.fitToViewport();
        }, 100);
        setTimeout(() => {
            window.MapApp.map.container.fitToViewport();
        }, 300);
        setTimeout(() => {
            window.MapApp.map.container.fitToViewport();
        }, 500);
    }
}
